import { configureStore } from "@reduxjs/toolkit";
import videosReducer from "../features/videos/videosSlice";
import videoReducer from "../features/video/videoSlice";
import tagsReducer from "../features/tags/tagsSlice";
import reletedVideoReducer from "../features/reletedVideo/reletedVideoSlice";
import filterReducer from "../features/filter/filterSlice";
import likeReducer from "../features/likeUnlike/likeUnlikeSlice";
import unlikeReducer from "../features/likeUnlike/unlikeSlice";

export const store = configureStore({
  reducer: {
    videos: videosReducer,
    tags: tagsReducer,
    video: videoReducer,
    reletedVideos: reletedVideoReducer,
    filter: filterReducer,
    like: likeReducer,
    unlike: unlikeReducer,
  },
});
